import { THttpService } from '@/services/HttpService';

import { getValue } from '@/helpers/GetValueHelper';

import { TRecommendation as TRecommendation1 } from './types/template1';
import { TRecommendation as TRecommendation2 } from './types/template2';
import { TRecommendation as TRecommendation3 } from './types/template3';
import { TRecommendation as TRecommendation4 } from './types/template4';
import { TRecommendation as TRecommendation5 } from './types/template5';
import { TRecommendation as TRecommendation6 } from './types/template6';
import { TRecommendation as TRecommendation7 } from './types/template7';

type TRecommendation =
  | TRecommendation1[]
  | TRecommendation2[]
  | TRecommendation3[]
  | TRecommendation4[]
  | TRecommendation5[]
  | TRecommendation6[]
  | TRecommendation7[];

export const responseRecommendation = (
  id: string,
  type: string,
  data: TRecommendation,
) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const recommendations = getValue(data, 'recommendations', []) as any[];
  return recommendations.map(item => ({
    ...item,
    idLiferay: item.id,
    type,
    id,
    config: getValue(data, 'config', {}),
    place: getValue(data, 'place', ''),
    channel: getValue(data, 'channel', ''),
    layout: getValue(data, 'layout', ''),
    tag_events: getValue(data, 'tag_events', []),
  }));
};

export const getRecommendationData = async (
  api: THttpService,
  id: string,
  type: string,
  place: string,
  channel?: string,
  supportGeolocation?: boolean,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any[]> => {
  let url = `recommendation?place=${place}&channel=${channel}&id=${id}`;

  url += await new Promise(resolve => {
    if (supportGeolocation && navigator.geolocation) {
      navigator.geolocation.watchPosition(
        ({ coords }) => {
          resolve(`&lat=${coords.latitude}&lon=${coords.longitude}`);
        },
        () => {
          resolve('');
        },
      );
    } else {
      resolve('');
    }
  });

  const { data } = await api.get(url);
  return responseRecommendation(id, type, data);
};
